<div class="content">
  <h1>🎉</h1>
  <h1>Thank You for Registering!</h1>
  <p>
    We've sent a verification email to <b>{{email}}</b>. Please check your inbox
    (and spam/junk folder 📩) and click the link to verify your account. ✅
  </p>

  <p>
    Once verified, you'll have full access to our platform! 🚀 If you don't
    receive the email within a few minutes, you can request a new one below.
  </p>

  <div class="actions">
    <app-button [loading]="loading" (onClick)="resend()" [disabled]="timeout>0"
      >Resend @if (timeout>0) {({{timeout}})}</app-button
    >
    <app-button routerLink="/" aria-label="Home Page"
      >Continue Shopping</app-button
    >
  </div>
</div>
